import { createSelector } from 'reselect'

import { TriggerRuleId } from 'shared/api/common/schemas/flow/triggerRule'

import { CurrentTriggerRule } from '../types'

/* ------------------
   CurrentTriggerRule
   ------------------ */

const EMPTY_TRIGGER_RULE: CurrentTriggerRule = {
  item: null,
  fetching: false,
  error: null,
  saving: false,
  hasChanges: false,
  isDeleted: false,
}

export const getCurrentTriggerRule = (state: RootState, id: TriggerRuleId) => {
  return state.triggerRules.current[id] ?? EMPTY_TRIGGER_RULE
}

export const getTriggerRulesCreating = (state: RootState) => {
  return state.triggerRules.creating
}

export const getTriggerRulesFetching = (state: RootState) => {
  return state.triggerRules.fetching
}

export const getCurrentTriggerRuleError = createSelector(
  [getCurrentTriggerRule],
  (rule) => rule.error,
)

export const getCurrentTriggerRuleItem = createSelector(
  [getCurrentTriggerRule],
  (rule) => rule.item,
)

export const isTriggerRuleChanged = (state: RootState, id: TriggerRuleId) => {
  const rule = getCurrentTriggerRule(state, id)
  return Boolean(rule.hasChanges)
}

export const isTriggerRuleSaving = (state: RootState, id: TriggerRuleId) => {
  const rule = getCurrentTriggerRule(state, id)

  return Boolean(rule.saving)
}

export const isTriggerRuleDeleted = (state: RootState, id: TriggerRuleId) => {
  const rule = getCurrentTriggerRule(state, id)

  return Boolean(rule.isDeleted)
}

export const getTriggerRules = (state: RootState) => {
  return state.triggerRules.items
}

export const getTriggerRuleById = createSelector(
  [getTriggerRules, (_: RootState, id: TriggerRuleId) => id],
  (items, id) => items.find((triggerRule) => triggerRule.id === id) ?? null,
)
